import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../routes/paths';
import { Features } from '../../../assets/features/Features';
import aboutImage from '../../../assets/img/about_us/2.jpg';
import { useLanguage } from '../../../context/LanguageContext';

const About: React.FC = () => {
  const { language } = useLanguage();
  
  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-6" data-aos="fade-right">
            <img src={aboutImage} className="img-fluid rounded-4" alt="" />
          </div>
          <div className="col-lg-6 content ps-lg-5" data-aos="fade-left">
            <h2 style={{ paddingTop: '20px' }}>{Features.about.title[language]}</h2>
            <p className="fst-italic py-3">
              {Features.about.description[language]}
            </p>
            
            <div className="d-flex align-items-center mt-4">
              <i className="bi bi-check2-circle flex-shrink-0 text-primary me-3 fs-4"></i>
              <p>{Features.about.features.integratedTreatments.description[language]}</p>
            </div>
            
            <div className="d-flex align-items-center mt-4">
              <i className="bi bi-check2-circle flex-shrink-0 text-primary me-3 fs-4"></i>
              <p>{Features.about.features.personalizedGuidance.description[language]}</p>
            </div>
            
            <div className="d-flex align-items-center mt-4">
              <i className="bi bi-check2-circle flex-shrink-0 text-primary me-3 fs-4"></i>
              <p>{Features.about.features.holisticApproach.description[language]}</p>
            </div>
            
            <div className="mt-4">
              <blockquote className="blockquote fst-italic">
                <p>{Features.about.quote[language]}</p>
              </blockquote>
              <Link to={ROUTES.ABOUT_US} className="btn btn-primary rounded-pill mt-3">
                {Features.hero.learnMoreButton[language]}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 